// css
import "stylesheets/packs/desktop/watch.scss";

// JS
// Must Have
import "regenerator-runtime/runtime";
import "jquery";
import "lazysizes";
import Rails from "rails-ujs";
Rails.start();

// vendor
import "vendor/bootstrap-sass/assets/javascripts/bootstrap/transition"; // obscure usage: emulateTransitionEnd
import "javascripts/jquery.prompt";
import "javascripts/jquery.transit";
import "javascripts/typeahead.jquery";
import "bootstrap/js/dropdown";
import "bootstrap/js/modal";
import "bootstrap/js/tab";

// global objects
window.AhoyPageviewEvent = require("shared/ahoy_pageview_event").default;
window.GoogleOneTapTracker = require("components/shared/GoogleOneTapTracker/GoogleOneTapTracker").default;
window.LoginOfferingHelper = require("shared/components/login_offering_helper").default;

// components
window.Kmklabs = require("components/shared/Kmklabs/Kmklabs").default;
window.Autolink = require("components/shared/Autolink/Autolink").default;
window.FlashNotification = require("desktop/components/flash_notification").default;
window.TransparentHeaderAtTop = require("desktop/components/transparent_header_at_top").default;
window.KidsHeader = require("components/desktop/KidsHeader/KidsHeader").default;
window.SearchSuggestion = require("desktop/components/search_suggestion").default;
window.BackToTop = require("desktop/components/back_to_top").default;
window.ChannelPlaylist = require("shared/components/channel_playlist").default;
window.EmbedPopup = require("desktop/components/embed_popup").default;
window.RequireLoginModal = require("desktop/components/require_login_modal").default;
window.ReportButton = require("desktop/components/report_button").default;
window.AddToCollectionPopup = require("desktop/components/add_to_collection_popup").default;
window.Topic = require("shared/topic").default; // move to load_playback after permanent feature_toggle
window.ButtonFollow = require("desktop/components/button_follow").default;
window.CommentForm = require("desktop/components/comment_form").default;
window.PremiumBannerBenefitToggle = require("desktop/components/premium_banner_benefit_toggle").default;
window.WatchPlayerContainer = require("components/desktop/WatchPlayerContainer/WatchPlayerContainer").default;
window.WatchPlaylistContainer = require("components/desktop/watch/WatchPlaylist/WatchPlaylistContainer").default;
window.MuxLoader = require('components/shared/MuxLoader/MuxLoader').default;

import ShowMoreContent from "shared/show_more_content";
window.ShowMoreContent = ShowMoreContent; // used when user submits comment

import CollectionsListTracker from "desktop/components/plenty_tracker/collections_list_tracker";
import { SidebarRelatedVideos } from "shared/components/recommendation/sidebar_related_videos";
import ShowMoreCommentContent from "shared/components/comments/show_more_comment_content";
import ShowMoreReplies from "shared/components/comments/show_more_replies";
import CommentFilter from "shared/components/comment_filter";
import VideoVote from "shared/components/votes/video_vote";
import ShowMoreComments from "shared/show_more_comments";
import GtmWatch from "desktop/initializers/gtm_watch";
import PlayCount from "shared/components/play_count";
import VideoShowMore from "shared/video_show_more";
import Pip from "desktop/components/pip";
import MoreNav from "desktop/more_nav";

// initializers
import ComponentInitializers from "components/shared/ComponentInitializers/ComponentInitializers";
import InteractionStatus from "desktop/initializers/interaction_status";
import { ApiKey } from "../../commons/ApiKey";

$(document).ready(function () {
  new ComponentInitializers();

  ApiKey.getApiKey().finally(() => {
    ComponentInitializers.initJsApiComponent();
  });
  InteractionStatus.init();
  MoreNav.init_new($(".header-category__items"), ".header-category");
});

$(window).on("load", function () {
  new VideoShowMore(
    "#show-more-videos-gravity",
    ".toggle-gravity"
  ).initButton();

  new ShowMoreComments().init(
    ".comments",
    ".comments__list",
    ".comments__paginator-container"
  );

  new ShowMoreContent(
    ".js-comment-container",
    ".truncate .read-more-comment",
    ".hidden"
  ); // comments
  new ShowMoreContent(
    ".article-desc",
    ".partial-desc .read-more",
    ".full-desc"
  ); // description

  new ShowMoreCommentContent().init();
  new SidebarRelatedVideos().init();
  new CollectionsListTracker().track();
  new ShowMoreReplies().bindCommentsReply();
  new Pip().init();

  PlayCount.load();
  VideoVote.new();
  CommentFilter.new();
  GtmWatch.init();
});
